const r = 6_371_000;

const radians = (degrees: number) => {
  return degrees / 180 * Math.PI;
}

export const distance = (start?: number[], end?: number[]) => {
  if (!start || !end || start.length !== 2 || end.length !== 2) return 0;

  const latStart = radians(start[0]);
  const longStart = radians(start[1]);
  const latEnd = radians(end[0]);
  const longEnd = radians(end[1]);
  const deltaLat = latEnd - latStart;
  const deltaLong = longEnd - longStart;

  return 2 * r * Math.asin(
    Math.sqrt(
      Math.pow(Math.sin(deltaLat / 2), 2) +
      Math.cos(latStart) * Math.cos(latEnd) * Math.pow(Math.sin(deltaLong / 2), 2)
    )
  );
}
